import React, { useState } from 'react';

// données
import { useAuthContext } from '../context/AuthContext';
import  useTaskManagement  from '../hooks/Tasks/useTaskManagement';
import useUserPokemons from '../hooks/Pokemons/useUserPokemon';

// components
import TaskList from '../components/TaskList';

// styles
import styles from '../styles/TaskPage.module.css';
import stylesPeriod from '../styles/Period.module.css';


const TaskPage = ({period, onClose}) => {
    const nightClassName = () => {
        if (period === '_night') {
            console.log('night');
            return stylesPeriod._night;
        } else if (period === '_dawn') {
            console.log('dawn');
            return stylesPeriod._dawn;
        } else {
            console.log('day');
            return stylesPeriod._day;
        }
    };
    const { user } = useAuthContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { userPokemons } = useUserPokemons();
    
    console.log('TaskPage - user:', user);
    
    const { 
        tasks, 
        isLoading, 
        error,
    } = useTaskManagement(user?.id, userPokemons?.[0]);

    console.log('TaskPage - tasks bruts:', tasks);

    console.log('TaskPage - tasks reçues:', tasks);

    console.log('Modal est ouvert:', isModalOpen);

    // Gestion des états de chargement et d'erreur
    if (!user || isLoading) {
        return;
    }

    if (error) {
        return (
            <div className={`${styles.errorContainer}`}>
                <p>Erreur: {error}</p>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={`${styles.pageContainer}`}>
                <div className={`${styles.taskPageContainer}}`}>
                    <TaskList 
                        tasks={tasks || []}
                        userPokemon={userPokemons?.[0]}
                        period={period}
                        onClose={onClose}
                    />
                </div>
            </div>
        </div>
    );
};

export default TaskPage;